import { render, staticRenderFns } from "./RenewPayment.vue?vue&type=template&id=53b4d5a3&scoped=true"
import script from "./RenewPayment.vue?vue&type=script&lang=js"
export * from "./RenewPayment.vue?vue&type=script&lang=js"
import style0 from "./RenewPayment.vue?vue&type=style&index=0&id=53b4d5a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b4d5a3",
  null
  
)

export default component.exports